<template>
  <AdminBackground>
    <div class="content-wrapper">
      <div class="image-wrapper">
        <img
          src="@/assets/header/PENGURUSAN DATA.png"
          alt="PENGURUSAN DATA"
          class="pbt-image"
        >
        <div class="line-under-image" />
      </div>
      <div class="pbtpay-status">
        <h2>Ahli Majlis</h2>
        <VBreadcrumbs
          :items="items"         
          class="breadcrumbs"
        >
          <template #title="{ item }">
            {{ item.title }}
          </template>
        </VBreadcrumbs>
        <!-- Dynamic Table for Batch Status -->
        <table class="status-table">
          <thead>
            <tr>
              <th>Batch ID</th>
              <th>Dimuat Naik Pada</th>
              <th>Tahun</th>
              <th>Aktif</th>
              <th>Buang</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in tableData"
              :key="index"
            >
              <td>{{ row.batchId }}</td>
              <td>{{ row.uploadedOn }}</td>
              <td>{{ row.year }}</td>
              <td>
                <span
                  v-if="row.active"
                  class="active-icon"
                >✔️</span>
              </td>
              <td>
                <button
                  class="remove-button"
                  @click="removeRow(index)"
                >
                  Buang
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <PrimaryModule />
  </AdminBackground>
</template>

<script setup>
import { ref } from 'vue'

definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const items = ref([
  {
    title: 'Dashboard',
    disabled: false,
    href: 'pengurusan-data',
  },
  {
    title: 'Dasar',
    disabled: false,
    href: '',
  },
  {
    title: 'Ahli Majlis',
    disabled: true,
    href: '',
  },
])

// Table data array
const tableData = ref([
  { batchId: '63904d57bbb87', uploadedOn: '28 Oct 2024', year: '2021', active: true },
  { batchId: '63e5ff6ede787', uploadedOn: '28 Oct 2024', year: '2021', active: true },
  { batchId: '63e5ffc9d4b4', uploadedOn: '28 Oct 2024', year: '2021', active: true },
  { batchId: '63e5ffc9d4b4', uploadedOn: '28 Oct 2024', year: '2023', active: true },
  { batchId: '63e5ffc9d4b4', uploadedOn: '28 Oct 2024', year: '2022', active: true },
  { batchId: '63e5ffc9d4b4', uploadedOn: '28 Oct 2024', year: '2024', active: true },
])

// Method to remove a row from the table
const removeRow = index => {
  tableData.value.splice(index, 1)
}
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  inline-size: 100%;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; /* Match width to the image size */
  margin-block-start: 10px;
}

h2 {
  display: block;
  color: #150069;
  font-size: 30px;
  font-weight: 600;
  font-weight: bold;
  margin-block-end: 20px;
  text-align: start;
}

.pbtpay-status {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 65%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%);
  inline-size: 100%;
  margin-block-end: 50px;
  max-inline-size: 1200px;
}



/* Table Styling */
.status-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
}

.status-table th, .status-table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

.status-table th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #333;
  text-transform: uppercase;
}

.status-table td {
  color: #000;
}

.active-icon {
  color: #2ecc71; /* Green color for active status */
  font-size: 16px;
}

.remove-button {
  color: red;
  background: none;
  border: none;
  cursor: pointer;
}

.remove-button:hover {
  text-decoration: underline;
}
</style>
